import Microgame from '../engine/Microgame.js';

export default class FillGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Remplis !`, en: `Fill!`, es: `¡Llena!` },
            controls: { fr: `Maintiens enfoncé pour remplir`, en: `Hold down to fill`, es: `Mantén presionado para llenar` },
            objective: { fr: `Atteins exactement la ligne cible, sans la dépasser`, en: `Reach the target line exactly, without overfilling`, es: `Alcanza la línea objetivo exacta, sin pasarte` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M4 4h16v16H4z"/><path d="M4 14h16"/></svg>`,
            actions: [
                { type: 'hold', x: 50, y: 70, duration: 180, holdDuration: 980 },
                { type: 'wait', duration: 450 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.level = 0;

        // Target is an area at the top of the glass. 
        // e.g. from 75% to 95%. User must stop within this zone.
        this.targetZoneStart = 70 + Math.random() * 15; // 70 to 85
        this.targetZoneHeight = 15; // 15% height window
        this.targetZoneEnd = this.targetZoneStart + this.targetZoneHeight;

        this.isFilling = false;
        this.hasFinished = false;
    }

    setup() {
        this.engine.ui.instruction.textContent = "FILL!";

        // Glass
        const glass = document.createElement('div');
        glass.style.position = 'absolute';
        glass.style.bottom = '20%';
        glass.style.left = '50%';
        glass.style.transform = 'translateX(-50%)';
        glass.style.width = '100px';
        glass.style.height = '200px';
        glass.style.border = `5px solid ${this.secondaryColor}`;
        glass.style.borderTop = 'none';
        glass.style.borderRadius = '0 0 20px 20px';
        glass.style.overflow = 'hidden';
        glass.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        this.container.appendChild(glass);

        // Target Zone (Green transparent block)
        const zone = document.createElement('div');
        zone.style.position = 'absolute';
        zone.style.bottom = `${this.targetZoneStart}%`;
        zone.style.left = '0';
        zone.style.width = '100%';
        zone.style.height = `${this.targetZoneHeight}%`;
        zone.style.background = 'rgba(204, 255, 0, 0.3)'; // Semi transparent lime/green
        zone.style.borderTop = '2px dashed #ccff00';
        zone.style.borderBottom = '2px dashed #ccff00';
        zone.style.zIndex = '10';
        glass.appendChild(zone);

        // Liquid
        this.liquid = document.createElement('div');
        this.liquid.style.position = 'absolute';
        this.liquid.style.bottom = '0';
        this.liquid.style.left = '0';
        this.liquid.style.width = '100%';
        this.liquid.style.height = '0%';
        this.liquid.style.background = this.primaryColor;
        this.liquid.style.opacity = '0.9';
        // DELIBERATELY NO CSS TRANSITION here, otherwise visual lags actual logic
        glass.appendChild(this.liquid);

        // Controls
        this.onDown = this.onDown.bind(this);
        this.onUp = this.onUp.bind(this);

        this.engine.input.element.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
        this.engine.input.element.addEventListener('pointerleave', this.onUp);
        this.engine.input.element.addEventListener('pointercancel', this.onUp);
    }

    onDown() {
        if (!this.active || this.hasFinished) return;
        this.isFilling = true;
    }

    onUp() {
        if (!this.active || !this.isFilling || this.hasFinished) return;
        this.isFilling = false;
        this.hasFinished = true;
        this.checkWin();
    }

    update(dt) {
        if (this.isFilling && !this.hasFinished) {
            // Speed scaling eased: instead of strictly multiplying by x4, it scales up gently
            // x1 = 1.0, x4 = 1.9 speed. Still fast, but allows human reaction time!
            const sm = this.engine.speedMultiplier || 1.0;
            const effectiveSpeed = 1.0 + (sm - 1) * 0.3;
            this.level += dt * 0.08 * effectiveSpeed;

            this.liquid.style.height = `${this.level}%`;

            // Overflow with a small tolerance (letting them scrape by if they are visually overlapping)
            if (this.level > this.targetZoneEnd + 3) {
                this.isFilling = false;
                this.hasFinished = true;
                this.liquid.style.background = 'red'; // Visual indicator of failure
                this.lose();
            }
        }
    }

    checkWin() {
        // Generous grace period of ±4% to avoid "I clearly won but game says no" due to frame jumping
        if (this.level >= this.targetZoneStart - 4 && this.level <= this.targetZoneEnd + 3) {
            this.liquid.style.background = '#ccff00'; // Success color
            this.win();
        } else {
            this.liquid.style.background = 'red'; // Too low
            this.lose();
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
        this.engine.input.element.removeEventListener('pointerleave', this.onUp);
        this.engine.input.element.removeEventListener('pointercancel', this.onUp);
    }
}
